// extracted by mini-css-extract-plugin
export default {"container":"MethodSlider_container__hnDIW","method":"MethodSlider_method__FzLMd","activeMethod":"MethodSlider_activeMethod__qCRRo","label":"MethodSlider_label__vXADk"};